import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../../App.scss';
import 'antd/dist/antd.css';
import {
  QrcodeOutlined,
  SettingOutlined,
  UserAddOutlined,
  ArrowRightOutlined,
  UnorderedListOutlined,
  HeartOutlined,
  BankOutlined,
  DownloadOutlined,
  FileExcelOutlined,
  EditOutlined,
  FilePdfOutlined,
} from '@ant-design/icons';
import {
  Button,
  Space,
  Card,
  Typography,
  Divider,
  Skeleton,
  Row, Col,
  Image,
  Alert,
  Tag,
  message,
} from 'antd';
import firebase from 'firebase/app';

import { RestrictedTeamPermissions } from '../../utils/Constants';
import { UserContext } from '../../providers/UserProvider';
import QRImageView from '../customer/QRImageView';
import MoneyTitle from '../customer/MoneyTitle';
import TrackerService from '../../utils/TrackerService';
import { useTeamTagsCount } from '../../models/useTeamTagsCount';
import { useTeamHasSites } from '../../models/useTeamHasSites';
import striketipLogo from '../../images/striketip_black_text_url.png';

import { TeamMembersGrid, TeamProfileTeamMembersAction , ActionButtonCol , TeamLeaveTeamCard } from './TeamProfileComponents';
import { useClientBalances } from './useClientBalances';
import { TeamMemberInviteModal } from './TeamMemberInviteModal';
import { TeamMemberLeaveButton } from './TeamMemberLeaveButton';
import { TeamProfileRecentActivityList } from './TeamProfileRecentActivityList';
import { useClientDetails } from './useClientDetails';
import DevicesAndQRSection from './DevicesAndQRSection';
import BuyTippingStandsSection from './BuyTippingStandsSection';


const { Paragraph, Text } = Typography;

function getRoleTitleForMember({ team, member }) {
  const isOwner = (team.teamOwnerClientId === member.clientId);
  const isManager = member.permissions && member.permissions.isTeamAdmin;
  const role = isOwner ? 'You are the owner'
    : (isManager ? 'You are a manager' : `You are a ${member.roles[0]}`);
  return role;
}

const TeamPofileTeamMembersActions = ({ teamId, permissions, isOldTeamSettings, isMobile }) => {
  const isTeamAdmin = permissions ? permissions.isTeamAdmin : false;
  const canSeeAllTxns = permissions ? permissions.canSeeAllTxns : false;

  return <Row gutter={[{ xs: 4, sm: 6, md: 10, lg: 32 }, { xs: 2, sm: 3, md: 6, lg: 8 }]}>
    {/* {(isTeamAdmin || canAddMembers || canSeeMembers || canPayMembers) &&
      <ActionButtonCol>
        <TeamProfileTeamMembersAction
          route={`./${teamId}/members`}
          text={'Manage Members'}
          icon={<TeamOutlined />}
          style={{ width: '100%' }} />
      </ActionButtonCol>
    } */}
    {/* {(isTeamAdmin || canPayMembers) &&
      <ActionButtonCol>
        <TeamProfileTeamMembersAction
          route={`./${teamId}/payouts`}
          text={'Payouts'}
          icon={<EuroCircleOutlined />}
          style={{ width: '100%' }} />
      </ActionButtonCol>
    } */}
    {(isTeamAdmin || canSeeAllTxns) &&
      <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: '16px' }}>
        <Card
          style={{
            width: '100%',
            borderRadius: '8px',
            border: '1px solid #d9d9d9',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}
          bodyStyle={{ padding: '20px' }}
        >
          <div style={{ 
            display: 'flex', 
            flexDirection: isMobile ? 'column' : 'row', 
            alignItems: isMobile ? 'flex-start' : 'center',
            justifyContent: 'space-between', 
            gap: '16px', 
            flexWrap: 'wrap' 
          }}>
            <div style={{ flex: 1, minWidth: isMobile ? '0' : '200px', width: isMobile ? '100%' : 'auto' }}>
              <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px' }}>
                Tip summary reports
              </Text>
              <Text type="secondary" style={{ fontSize: '14px', display: 'block' }}>
                Export tip reports by team member. Add staff numbers for easier accounting integration.
              </Text>
            </div>
            <div style={{ 
              flexShrink: 0,
              width: isMobile ? '100%' : 'auto',
              display: 'flex',
              justifyContent: isMobile ? 'center' : 'flex-start'
            }}>
              <Link to={`./${teamId}/members-tips`} style={{ display: 'block' }}>
                <Button
                  type="primary"
                  size="large"
                  icon={<FileExcelOutlined />}
                  style={{
                    height: '40px',
                    padding: '0 24px',
                    fontSize: '16px',
                    fontWeight: 500,
                    borderRadius: '6px'
                  }}
                >
                  Create Report
                </Button>
              </Link>
            </div>
          </div>
        </Card>
      </Col>
    }
  </Row>;
};

const TeamInviteButton = ({ isAdmin, onClick, team, displayPermissions, style }) => {
  const text = 'Invite team members';
  const color = 'green';
  const ActionIcon = <
    UserAddOutlined color={color} 
    style={{ 
      fontSize: '200%', 
      width: '40px',
      borderRadius: '40px', 
      border: '1px solid green', 
      padding: '2px',
      margin: '0px 0px 0px 0px'
    }}
  />;
  const innerStyle = { 
    marginLeft: '20px', 
    marginTop: '4px', 
    height: '48px',
    color, 
    textAlign: 'left', 
    borderRadius: '4px',
    padding: '0px 10px 0px 10px',
    ...style,
  };

  return ( isAdmin || displayPermissions.canAddMembers ) && (
      <Button
        onClick={() => (onClick())}
        icon={ActionIcon}
        style={innerStyle}
      >
        <Space direction='vertical' align='center' style={{paddingLeft: '12px'}}>
          <Text strong ellipsis style={{ paddingBottom: '4px'}}> {text} </Text>
        </Space>
      </Button>
  );

}

const SmartPosCTA = ({
  team, teamId, canManage, clientId,
}) => {
  const [enabling, setEnabling] = useState(false);
  // null = unknown (checking); the CTA stays hidden until devices confirm.
  const [deviceCount, setDeviceCount] = useState(null);
  const enabled = !!team.smartPosEnabled;

  useEffect(() => {
    // Roll-out gate: the Activate button only appears once the location has
    // been PREPPED — at least one tag with deviceKind set (terminal/stand),
    // labeled and identifiable. One-shot read; same teamId-only query as the
    // POS device list to avoid a composite index (a team owns a handful).
    if (enabled || !canManage) return;
    firebase.firestore().collection('tags')
      .where('teamId', '==', teamId)
      .get()
      .then((snap) => {
        let count = 0;
        snap.forEach((doc) => {
          const kind = doc.data().deviceKind;
          if (['terminal', 'stand', 'sticker', 'card', 'fob'].includes(kind)) count += 1;
        });
        setDeviceCount(count);
      })
      .catch(() => setDeviceCount(0));
  }, [teamId, enabled, canManage]);

  if (!enabled && !canManage) return null;
  if (!enabled && !(deviceCount > 0)) return null;

  const turnOn = async () => {
    setEnabling(true);
    try {
      await firebase.firestore().collection('teams').doc(teamId).update({ smartPosEnabled: true });
      message.success('Smart POS is on for this team');
      new TrackerService({ isTest: !!team.is_test }).mixpanelTrack('smartpos_team_activated', {
        teamId,
        teamName: team.teamName,
        currency: team.defaultCurrency || 'EUR',
        clientId,
        teamOwnerClientId: team.teamOwnerClientId || team.teamClientId || null,
      });
    } catch (e) {
      message.error('Could not enable Smart POS');
    } finally {
      setEnabling(false);
    }
  };

  return (
    <Card
      style={{
        width: '100%', borderRadius: '8px', border: '1px solid #d9d9d9',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '16px',
      }}
      bodyStyle={{ padding: '20px' }}
    >
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        gap: '16px', flexWrap: 'wrap',
      }}>
        <div style={{ flex: 1, minWidth: '220px' }}>
          <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px' }}>
            Smart POS
          </Text>
          <Text type="secondary" style={{ fontSize: '14px', display: 'block' }}>
            {enabled
              ? 'Start a payment and hand it off — QR stands, terminals, links, with live session tracking.'
              : 'Turn on Smart POS to start payments at the counter and hand them off to QR stands and terminals.'}
          </Text>
        </div>
        <div style={{ flexShrink: 0 }}>
          {enabled ? (
            <Link to={`./${teamId}/pos`} style={{ display: 'block' }}>
              <Button
                type="primary"
                size="large"
                icon={<ArrowRightOutlined />}
                style={{ height: '40px', padding: '0 24px', fontSize: '16px', fontWeight: 500, borderRadius: '6px' }}
              >
                Open Smart POS
              </Button>
            </Link>
          ) : (
            <Button
              type="primary"
              size="large"
              loading={enabling}
              onClick={turnOn}
              style={{ height: '40px', padding: '0 24px', fontSize: '16px', fontWeight: 500, borderRadius: '6px' }}
            >
              Turn on Smart POS
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

const TeamMembersSummary = ({ isAdmin, team }) => {
  const teamNumberOfDeletedMembers = team && team.teamNumberOfDeletedMembers ? team.teamNumberOfDeletedMembers : 0;
  const teamTotalNumberOfMembers = teamNumberOfDeletedMembers > 0 ? team.teamNumberOfMembers + teamNumberOfDeletedMembers : team.teamNumberOfMembers;

  return (
    <Space direction='horizontal' align='center' style={{ width: '100%' }}>
      {`${teamTotalNumberOfMembers} ${teamTotalNumberOfMembers === 1 ? "member" : "members"} `}
      {isAdmin && `(${team.teamNumberOfDeletedMembers} deleted, `}
      {isAdmin && `${team.teamNumberOfMembers} active)`}
    </Space>
  );
}

const TeamProfileScreenBody = ({
  locStrings,
  teamId,
  team,
  clientId,
  teamMembers,
  isAdmin,
}) => {
  const context = useContext(UserContext);
  const user = context.user;
  const client = useClientDetails(clientId);

  // Classic Tip behavior for teams without Smart POS: open the tip page on
  // pay.* carrying the signed-in user via a short-lived custom token.
  const openTipPage = async (tipTagId) => {
    const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:8088' : 'https://pay.strikepay.co';
    const win = window.open('about:blank', '_blank');
    let tagUrl = `${baseUrl}/tags/${tipTagId}`;
    try {
      const authUser = firebase.auth().currentUser;
      if (authUser && !authUser.isAnonymous) {
        const res = await firebase.functions().httpsCallable('userService-sessionTokenHandler-mintSignInToken')();
        const customToken = res && res.data && res.data.customToken;
        if (customToken) {
          const u = new URL(tagUrl);
          u.searchParams.set('token', customToken);
          tagUrl = u.toString();
        }
      }
    } catch (e) {
      console.warn('[Tip] session token mint failed, opening without sign-in:', e && e.message);
    }
    if (win) win.location.href = tagUrl; else window.location.href = tagUrl;
  };

  const { isOldTeamSettings } = client || { isOldTeamSettings: false };

  const [isQRVisible, setIsQRVisible] = useState(false);
  const [isBalanceVisible, setIsBalanceVisible] = useState(true);
  const [isInviteVisible, setIsInviteVisible] = useState(false);
  const [isTopLogoError, setIsTopLogoError] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  
  // Get tags count for the team
  const tagsCount = useTeamTagsCount(teamId);
  
  // Check if team has any sites
  const hasSites = useTeamHasSites(teamId);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  const isMobile = screenWidth <= 768;
  // Use stacked header layout on wider breakpoint to avoid squashing when many buttons (e.g. owner with Delete)
  const isHeaderStacked = screenWidth <= 992;

  const override = false;
  const yourself = teamMembers && teamMembers.find(m => m.clientId === clientId);
  const role = yourself && team && getRoleTitleForMember({ member: yourself, team });
  const teamCardTitle = role;

  const restrictedPermissions = {
    ...RestrictedTeamPermissions,
  };
  const displayPermissions = (yourself && yourself.permissions) ? yourself.permissions : restrictedPermissions;
  const limitSettings = ['owner', 'manager'];
  const canAccessSettings = limitSettings.includes(yourself && yourself.roles && yourself.roles.length > 0 ? yourself.roles[0] : '');
  const isTeamAdmin = displayPermissions ? displayPermissions.isTeamAdmin : false;
  const canPayMembers = displayPermissions ? displayPermissions.canPayMembers : false;
  const canSeeTeamBalance = displayPermissions ? displayPermissions.canSeeTeamBalance : false;
  
  // Get team balances
  const teamClientBalances = useClientBalances(team && team.teamClientId ? team.teamClientId : null);
  
  // Check if pooling is enabled (team or both)
  const isPoolingEnabled = team && team.teamTapBehaviour && (
    team.teamTapBehaviour === 'team' || 
    team.teamTapBehaviour === 'both'
  );
  
  // Check if team has balance > 0
  const hasTeamBalance = teamClientBalances && teamClientBalances.some(account => account.available > 0);
  
  // Show balance card for pooled teams OR teams with balance
  const shouldShowBalanceCard = (isTeamAdmin || canSeeTeamBalance || canPayMembers) && (isPoolingEnabled || hasTeamBalance);

  const teamNumberOfDeletedMembers = team && team.teamNumberOfDeletedMembers ? team.teamNumberOfDeletedMembers : 0;
  const teamTotalNumberOfMembers = teamNumberOfDeletedMembers > 0 ? team.teamNumberOfMembers + teamNumberOfDeletedMembers : team.teamNumberOfMembers;

  // Always show invite button in top bar if user has permissions (regardless of team size)
  const shouldShowInviteButton = isAdmin || (displayPermissions && displayPermissions.canAddMembers);

  // Show invite section card if user is admin or can add members AND team has <= 3 members
  const shouldShowInvite = shouldShowInviteButton && teamTotalNumberOfMembers <= 3;

  // Show reports section if user is team admin or can see all transactions
  const shouldShowReports = displayPermissions && (displayPermissions.isTeamAdmin || displayPermissions.canSeeAllTxns);

  // Show divider if there are any Team Setup Actions to display
  const shouldShowDivider = shouldShowInvite || (isTeamAdmin && !hasSites);

  return (team && teamMembers) ? (
    <>
      {isInviteVisible &&
        <TeamMemberInviteModal
          visible={true}
          teamId={teamId}
          teamName={team.teamName}
          team={team}
          clientId={clientId}
          clientName={yourself.displayName}
          canManageInvite={isTeamAdmin || isAdmin}
          teamMemberInviteUuid={team.inviteUuid ? team.inviteUuid : null}
          teamMemberInviteCreatedBy={team.inviteCreatedBy ? team.inviteCreatedBy : null}
          teamMemberInviteCreatedAt={team.inviteCreatedAt ? team.inviteCreatedAt : null}
          teamMemberInviteExpiresAt={team.inviteExpiresAt ? team.inviteExpiresAt : null}
          onClickInviteModalOk={() => setIsInviteVisible(false)}
          onClickModalCancel={() => setIsInviteVisible(false)}
        />
      }

      <Card
        loading={override}
        size='default'
      >

        {teamMembers && team &&
          <div style={{ width: '100%', marginBottom: '24px' }} >
            {/* Team Header - Logo and Name */}
            <div style={{ 
              display: 'flex', 
              flexDirection: isHeaderStacked ? 'column' : 'row',
              flexWrap: isHeaderStacked ? 'nowrap' : 'wrap',
              alignItems: 'flex-start', 
              justifyContent: 'space-between', 
              gap: '12px', 
              padding: '16px 0', 
              borderBottom: '1px solid #f0f0f0' 
            }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'flex-start', 
                gap: '12px', 
                flex: isHeaderStacked ? '1 1 100%' : '1 1 240px',
                minWidth: isHeaderStacked ? '100%' : '240px',
                width: '100%'
              }}>
                {/* Team Logo/Initials */}
                <div style={{ 
                  position: 'relative',
                  flexShrink: 0
                }}>
                  <div style={{ 
                    width: '60px', 
                    height: '60px', 
                    borderRadius: '8px', 
                    border: '1px solid #d9d9d9',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white'
                  }}>
                    {!isTopLogoError && team.topLogo ? (
                      <Image
                        src={team.topLogo}
                        alt={team.teamName}
                        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '8px' }}
                        preview={false}
                        onError={() => setIsTopLogoError(true)}
                      />
                    ) : (
                      <Text strong style={{ fontSize: '20px', color: '#595959' }}>
                        {team.teamName ? team.teamName.substring(0, 4).toUpperCase() : 'TEAM'}
                      </Text>
                    )}
                  </div>
                  {isTeamAdmin && (
                    <Link 
                      to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#general-image`} 
                      style={{ 
                        position: 'absolute',
                        bottom: '-4px',
                        right: '-4px',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        width: '24px',
                        height: '24px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        border: '1px solid #d9d9d9',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                      }}
                    >
                      <EditOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />
                    </Link>
                  )}
                </div>
                {/* Team Name and Description */}
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <Text strong style={{ fontSize: '20px', display: 'block' }}>
                      {team.teamName}
                    </Text>
                    {isTeamAdmin && (
                      <Link 
                        to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#general-name`} 
                        style={{ display: 'flex', alignItems: 'center' }}
                      >
                        <EditOutlined style={{ fontSize: '16px', color: '#8c8c8c', cursor: 'pointer' }} />
                      </Link>
                    )}
                  </div>
                  <div style={{ marginTop: team.teamDescription ? '0' : '4px' }}>
                    {team.teamDescription ? (
                      <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                        <Text style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          {team.teamDescription}
                        </Text>
                        {isTeamAdmin && (
                          <Link 
                            to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#general-name`} 
                            style={{ display: 'inline-flex', alignItems: 'center' }}
                          >
                            <EditOutlined style={{ fontSize: '14px', color: '#8c8c8c', cursor: 'pointer' }} />
                          </Link>
                        )}
                      </div>
                    ) : (
                      isTeamAdmin && (
                        <Link 
                          to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#general-name`} 
                          style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}
                        >
                          <EditOutlined style={{ fontSize: '14px', color: '#1890ff', cursor: 'pointer' }} />
                          <Text style={{ fontSize: '14px', color: '#1890ff' }}>+ Add description</Text>
                        </Link>
                      )
                    )}
                  </div>
                </div>
              </div>
              
              {/* Action Buttons - Horizontal on wide screens, Grid when stacked */}
              {!isHeaderStacked ? (
                <div style={{ 
                  display: 'flex', 
                  flexDirection: 'row',
                  flexWrap: 'wrap',
                  gap: '8px', 
                  alignItems: 'center', 
                  flex: '0 1 auto',
                  minWidth: 0,
                  justifyContent: 'flex-end'
                }}>
                  {/* Show QR Button */}
                  {team.defaultTagId && (
                    <Button
                      type="default"
                      style={{
                        border: '1px solid #000',
                        backgroundColor: 'white',
                        color: '#000',
                        borderRadius: '6px',
                        height: 'auto',
                        padding: '8px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flexShrink: 0,
                        justifyContent: 'center'
                      }}
                      onClick={() => setIsQRVisible(!isQRVisible)}
                    >
                      <QrcodeOutlined style={{ fontSize: '16px' }} />
                      <span>{isQRVisible ? 'Hide QR' : 'Show QR'}</span>
                    </Button>
                  )}
                  {/* Settings Button */}
                  {isTeamAdmin && (
                    <Link to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings`} style={{ display: 'block' }}>
                      <Button
                        type="default"
                        style={{
                          border: '1px solid #000',
                          backgroundColor: 'white',
                          color: '#000',
                          borderRadius: '6px',
                          height: 'auto',
                          padding: '8px 16px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          flexShrink: 0,
                          justifyContent: 'center'
                        }}
                      >
                        <SettingOutlined style={{ fontSize: '16px' }} />
                        <span>Settings</span>
                      </Button>
                    </Link>
                  )}
                  {/* Invite Button - Always visible if user has permissions */}
                  {shouldShowInviteButton && (
                    <Button
                      type="default"
                      style={{
                        border: '1px solid #000',
                        backgroundColor: 'white',
                        color: '#000',
                        borderRadius: '6px',
                        height: 'auto',
                        padding: '8px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flexShrink: 0,
                        justifyContent: 'center'
                      }}
                      onClick={() => setIsInviteVisible(true)}
                    >
                      <UserAddOutlined style={{ fontSize: '16px' }} />
                      <span>Invite</span>
                    </Button>
                  )}
                  {/* Leave Button - non-admins only; Delete moved to bottom danger zone */}
                  {(!isTeamAdmin && clientId && team) && (
                    <TeamMemberLeaveButton
                      clientId={clientId}
                      team={team}
                      isAdmin={isAdmin}
                      style={{
                        border: '1px solid #000',
                        backgroundColor: 'white',
                        color: '#000',
                        borderRadius: '6px',
                        height: 'auto',
                        padding: '8px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flexShrink: 0,
                        justifyContent: 'center'
                      }}
                    />
                  )}
                  {/* Tip Button — opens the in-app Smart POS chooser (a team activity;
                      the public tip page is one of its hand-off options). */}
                  {team.defaultTagId && (team.smartPosEnabled ? (
                    <Link to={`./${teamId}/pos`} style={{ flexShrink: 0 }}>
                      <Button
                        type="default"
                        style={{
                          border: '1px solid #000',
                          backgroundColor: 'white',
                          color: '#000',
                          borderRadius: '6px',
                          height: 'auto',
                          padding: '8px 16px',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '6px',
                          flexShrink: 0,
                          justifyContent: 'center'
                        }}
                      >
                        <HeartOutlined style={{ fontSize: '16px' }} />
                        <span>Tip</span>
                      </Button>
                    </Link>
                  ) : (
                    <Button
                      type="default"
                      style={{
                        border: '1px solid #000',
                        backgroundColor: 'white',
                        color: '#000',
                        borderRadius: '6px',
                        height: 'auto',
                        padding: '8px 16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        flexShrink: 0,
                        justifyContent: 'center'
                      }}
                      onClick={() => openTipPage(team.defaultTagId)}
                    >
                      <HeartOutlined style={{ fontSize: '16px' }} />
                      <span>Tip</span>
                    </Button>
                  ))}
                </div>
              ) : (
                <div style={{ width: '100%', marginTop: '12px' }}>
                  <Row gutter={[8, 8]}>
                    {/* Show QR Button */}
                    {team.defaultTagId && (
                      <Col xs={12} sm={8}>
                        <Button
                          type="default"
                          block
                          style={{
                            border: '1px solid #000',
                            backgroundColor: 'white',
                            color: '#000',
                            borderRadius: '6px',
                            height: 'auto',
                            padding: '8px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                          }}
                          onClick={() => setIsQRVisible(!isQRVisible)}
                        >
                          <QrcodeOutlined style={{ fontSize: '16px' }} />
                          <span>{isQRVisible ? 'Hide QR' : 'Show QR'}</span>
                        </Button>
                      </Col>
                    )}
                    {/* Settings Button */}
                    {isTeamAdmin && (
                      <Col xs={12} sm={8}>
                        <Link to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings`} style={{ display: 'block' }}>
                          <Button
                            type="default"
                            block
                            style={{
                              border: '1px solid #000',
                              backgroundColor: 'white',
                              color: '#000',
                              borderRadius: '6px',
                              height: 'auto',
                              padding: '8px 16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <SettingOutlined style={{ fontSize: '16px' }} />
                            <span>Settings</span>
                          </Button>
                        </Link>
                      </Col>
                    )}
                    {/* Invite Button - Always visible if user has permissions */}
                    {shouldShowInviteButton && (
                      <Col xs={12} sm={8}>
                        <Button
                          type="default"
                          block
                          style={{
                            border: '1px solid #000',
                            backgroundColor: 'white',
                            color: '#000',
                            borderRadius: '6px',
                            height: 'auto',
                            padding: '8px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                          }}
                          onClick={() => setIsInviteVisible(true)}
                        >
                          <UserAddOutlined style={{ fontSize: '16px' }} />
                          <span>Invite</span>
                        </Button>
                      </Col>
                    )}
                    {/* Leave Button - non-admins only; Delete moved to bottom danger zone */}
                    {(!isTeamAdmin && clientId && team) && (
                      <Col xs={12} sm={8}>
                        <TeamMemberLeaveButton
                          clientId={clientId}
                          team={team}
                          isAdmin={isAdmin}
                          style={{
                            border: '1px solid #000',
                            backgroundColor: 'white',
                            color: '#000',
                            borderRadius: '6px',
                            height: 'auto',
                            padding: '8px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px',
                            width: '100%'
                          }}
                        />
                      </Col>
                    )}
                    {/* Tip Button — opens the in-app Smart POS chooser */}
                    {team.defaultTagId && !team.smartPosEnabled && (
                      <Col xs={12} sm={8}>
                        <Button
                          type="default"
                          block
                          style={{
                            border: '1px solid #000',
                            backgroundColor: 'white',
                            color: '#000',
                            borderRadius: '6px',
                            height: 'auto',
                            padding: '8px 16px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: '6px'
                          }}
                          onClick={() => openTipPage(team.defaultTagId)}
                        >
                          <HeartOutlined style={{ fontSize: '16px' }} />
                          <span>Tip</span>
                        </Button>
                      </Col>
                    )}
                    {team.defaultTagId && team.smartPosEnabled && (
                      <Col xs={12} sm={8}>
                        <Link to={`./${teamId}/pos`} style={{ display: 'block' }}>
                          <Button
                            type="default"
                            block
                            style={{
                              border: '1px solid #000',
                              backgroundColor: 'white',
                              color: '#000',
                              borderRadius: '6px',
                              height: 'auto',
                              padding: '8px 16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              gap: '6px'
                            }}
                          >
                            <HeartOutlined style={{ fontSize: '16px' }} />
                            <span>Tip</span>
                          </Button>
                        </Link>
                      </Col>
                    )}
                  </Row>
                </div>
              )}
            </div>

          </div>
        }

        {/* QR Code Display */}
        {team.defaultTagId && isQRVisible && (
          <div style={{ textAlign: 'center', marginTop: '16px', marginBottom: '16px' }}>
            <div style={{ width: '240px', margin: '0 auto' }}>
              <QRImageView
                tagId={team.defaultTagId}
                tag={{ tagId: team.defaultTagId }}
                nosubtext
              />
            </div>
            <p style={{ fontSize: 13, color: '#555', maxWidth: 280, margin: '12px auto 4px' }}>
              Customers scan this QR code to leave a tip for your team. Print it and display it where customers can see it.
            </p>

            {/* Tipping Policy */}
            {team.tippingPolicy && (
              <div style={{ maxWidth: 400, margin: '16px auto 0', textAlign: 'left', border: '1px solid #e8e8e8', borderRadius: 8, padding: '12px 16px', background: '#fafafa' }}>
                <p style={{ fontWeight: 600, fontSize: 13, margin: '0 0 6px' }}>Tipping Policy</p>
                <div
                  style={{ fontSize: 13, color: '#444', lineHeight: 1.6 }}
                  dangerouslySetInnerHTML={{ __html: team.tippingPolicy }}
                />
              </div>
            )}

            <Space style={{ marginTop: 12 }}>
              <Button
                icon={<DownloadOutlined />}
                onClick={async () => {
                  const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:8088' : 'https://pay.strikepay.co';
                  const imgUrl = `${baseUrl}/qr/${team.defaultTagId}/png`;
                  const teamLabel = team.teamName || 'team';
                  try {
                    const res = await fetch(imgUrl);
                    const blob = await res.blob();
                    const file = new File([blob], `${teamLabel}-tip-qr.png`, { type: blob.type || 'image/png' });
                    if (navigator.share && navigator.canShare && navigator.canShare({ files: [file] })) {
                      await navigator.share({ files: [file], title: `${teamLabel} tipping QR code` });
                    } else {
                      const url = URL.createObjectURL(blob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = `${teamLabel}-tip-qr.png`;
                      link.click();
                      URL.revokeObjectURL(url);
                    }
                  } catch { /* ignore share cancellation */ }
                }}
              >
                Share
              </Button>

              <Button
                icon={<FilePdfOutlined />}
                onClick={async () => {
                  const baseUrl = window.location.hostname === 'localhost' ? 'http://localhost:8088' : 'https://pay.strikepay.co';
                  const imgUrl = `${baseUrl}/qr/${team.defaultTagId}/png`;
                  const tagUrl = `${baseUrl}/qr/${team.defaultTagId}`;
                  const teamLabel = team.teamName || 'team';
                  const descriptionHtml = team.teamDescription
                    ? `<p class="description">${team.teamDescription}</p>`
                    : '';
                  const policyHtml = team.tippingPolicy
                    ? `<div class="policy"><h2>Tipping Policy</h2><div class="policy-body">${team.tippingPolicy}</div></div>`
                    : '';

                  const addr = team.address || {};
                  const addrLines = [
                    addr['address-line-one'],
                    addr['address-line-two'],
                    addr.town,
                    addr.county,
                    addr.zip,
                    addr.country,
                  ].filter(Boolean);
                  const contact = team.contact || {};
                  const contactLines = [
                    contact.email,
                    contact.phone,
                    contact.mobile,
                  ].filter(Boolean);
                  const contactInfoHtml = (addrLines.length || contactLines.length)
                    ? `<div class="contact-info">
                        ${addrLines.length ? `<p class="contact-block">${addrLines.join(', ')}</p>` : ''}
                        ${contactLines.length ? `<p class="contact-block">${contactLines.join(' &nbsp;·&nbsp; ')}</p>` : ''}
                       </div>`
                    : '';

                  const toBase64 = async (url) => {
                    const res = await fetch(url);
                    const blob = await res.blob();
                    return new Promise((resolve) => {
                      const reader = new FileReader();
                      reader.onloadend = () => resolve(reader.result);
                      reader.readAsDataURL(blob);
                    });
                  };

                  let qrSrc = imgUrl;
                  let logoSrc = striketipLogo;
                  try {
                    [qrSrc, logoSrc] = await Promise.all([
                      toBase64(imgUrl),
                      toBase64(striketipLogo),
                    ]);
                  } catch { /* fall back to URLs */ }

                  const printWindow = window.open('', '_blank');
                  // window.open returns null when a pop-up blocker stops it —
                  // common, and previously an uncaught TypeError on the next line
                  // rather than anything the person could act on.
                  if (!printWindow || !printWindow.document) {
                    message.error('Allow pop-ups for this site to print the QR code.');
                    return;
                  }
                  printWindow.document.write(`<!DOCTYPE html>
<html>
<head>
  <meta charset="utf-8"/>
  <title>${teamLabel} — Tipping QR</title>
  <style>
    @page { size: A4; margin: 20mm; }
    @media print { body { -webkit-print-color-adjust: exact; print-color-adjust: exact; } }
    * { box-sizing: border-box; }
    body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; margin: 0; padding: 0; min-height: 100vh; display: flex; flex-direction: column; }
    .page { max-width: 160mm; width: 100%; margin: 0 auto; padding: 16mm 0 8mm; flex: 1; display: flex; flex-direction: column; align-items: center; gap: 8mm; }
    h1 { font-size: 28px; font-weight: 700; margin: 0; text-align: center; }
    .qr-img { width: 180px; height: 180px; display: block; }
    .scan-note { font-size: 13px; color: #555; text-align: center; margin: 0; }
    .description { font-size: 14px; color: #444; text-align: center; margin: 0; line-height: 1.5; }
    .policy { width: 100%; border: 1px solid #ddd; border-radius: 8px; padding: 12px 16px; }
    .policy h2 { font-size: 15px; font-weight: 600; margin: 0 0 8px; }
    .policy-body { font-size: 13px; line-height: 1.6; color: #333; }
    .policy-body ul, .policy-body ol { padding-left: 20px; margin: 4px 0; }
    .footer { width: 100%; max-width: 160mm; margin: 0 auto; padding: 6mm 0 0; border-top: 1px solid #eee; display: flex; flex-direction: column; align-items: center; gap: 4mm; }
    .footer img { height: 24px; opacity: 0.75; }
    .contact-info { width: 100%; text-align: center; }
    .contact-block { font-size: 12px; color: #666; margin: 2px 0; }
    .tag-url { font-size: 12px; color: #444; margin: 0; word-break: break-all; text-align: center; }
    .copyright { font-size: 11px; color: #aaa; margin: 0; }
  </style>
</head>
<body>
  <div class="page">
    <h1>${teamLabel}</h1>
    ${descriptionHtml}
    <img class="qr-img" src="${qrSrc}" alt="Tipping QR code"/>
    <p class="scan-note">Scan to leave a tip for our team</p>
    ${policyHtml}
  </div>
  <div class="footer">
    ${contactInfoHtml}
    <p class="tag-url">${tagUrl}</p>
    <img src="${logoSrc}" alt="striketip"/>
    <p class="copyright">© ${new Date().getFullYear()} powered by strikepay</p>
  </div>
  <script>window.onload = function(){ window.print(); }<\/script>
</body>
</html>`);
                  printWindow.document.close();
                }}
              >
                Print
              </Button>
            </Space>
          </div>
        )}

        {/* Full-width Balance Card */}
        {shouldShowBalanceCard && teamClientBalances && teamClientBalances.length > 0 && (
          <div style={{ marginTop: '16px', width: '100%' }}>
            {teamClientBalances.map((account) => {
              const balanceAmount = account.available || 0;
              const currency = account.currency || 'EUR';
              const payoutRoute = canPayMembers ? `./${teamId}/payout/${account.availableAccountId}` : null;
              
              return (
                <Card
                  key={`balance-card-${teamId}-${account.availableAccountId}`}
                  style={{
                    width: '100%',
                    borderRadius: '8px',
                    border: '1px solid #d9d9d9',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                  }}
                  bodyStyle={{ padding: '24px' }}
                >
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
                    {/* Balance Display */}
                    <div style={{ flex: 1, minWidth: '200px' }}>
                      <Text type="secondary" style={{ fontSize: '14px', display: 'block', marginBottom: '8px' }}>
                        Team Balance
                      </Text>
                      <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px' }}>
                        <Text strong style={{ fontSize: '36px', lineHeight: '1', color: balanceAmount > 0 ? '#52c41a' : '#8c8c8c' }}>
                          <MoneyTitle
                            amount={balanceAmount}
                            currency={currency}
                            digits={2}
                          />
                        </Text>
                      </div>
                    </div>
                    
                    {/* Payout Button */}
                    {canPayMembers && payoutRoute && (
                      <Link to={payoutRoute}>
                        <Button
                          type="primary"
                          size="large"
                          icon={<BankOutlined />}
                          style={{
                            height: '48px',
                            padding: '0 24px',
                            fontSize: '16px',
                            fontWeight: 500,
                            borderRadius: '6px'
                          }}
                        >
                          Payout to Members
                        </Button>
                      </Link>
                    )}
                  </div>
                </Card>
              );
            })}
          </div>
        )}

        {/* Show divider if there are actions to take */}
        {shouldShowDivider && (
          <Divider orientation='left'>Team Setup Actions</Divider>
        )}

        {/* Add Members to Team Section */}
        {shouldShowInvite && (
          <>
            <Card
              style={{
                width: '100%',
                backgroundColor: '#52c41a',
                borderRadius: '8px',
                border: 'none',
                marginBottom: '24px'
              }}
              bodyStyle={{ padding: '24px' }}
            >
              <div style={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px'
              }}>
                <div style={{ flex: 1, color: 'white' }}>
                  <Text strong style={{ fontSize: '16px', color: 'white', display: 'block', marginBottom: '8px' }}>
                    Invite Team Members
                  </Text>
                  <Text style={{ fontSize: '14px', color: 'white', opacity: 0.95 }}>
                    Adding new members to your team is as simple as sharing a link. Click the button to get started.
                  </Text>
                </div>
                <Button
                  type="default"
                  size="large"
                  icon={<UserAddOutlined />}
                  onClick={() => setIsInviteVisible(true)}
                  style={{
                    backgroundColor: 'white',
                    color: '#52c41a',
                    border: 'none',
                    borderRadius: '6px',
                    height: '48px',
                    padding: '0 24px',
                    fontSize: '16px',
                    fontWeight: 500,
                    flexShrink: 0
                  }}
                >
                  Invite
                </Button>
              </div>
            </Card>
          </>
        )}

        {/* Tip Success Setup Section - Only show when no sites have been added */}
        {isTeamAdmin && !hasSites && (
          <>
            <Card
              style={{
                width: '100%',
                borderRadius: '8px',
                border: '1px solid #d9d9d9',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                marginBottom: '24px'
              }}
              bodyStyle={{ padding: '24px' }}
            >
              <div style={{ 
                display: 'flex', 
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '16px'
              }}>
                <div style={{ flex: 1 }}>
                  <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px' }}>
                    Add reviews, bookings, shopping and loyalty
                  </Text>
                  <Text style={{ fontSize: '14px', color: '#595959', display: 'block' }}>
                    Enhance your tip success experience by adding reviews, booking apps, shopping affiliates, and loyalty programs.
                  </Text>
                </div>
                <Link 
                  to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#actions`} 
                  style={{ flexShrink: 0 }}
                >
                  <Button
                    type="default"
                    size="large"
                    icon={<SettingOutlined />}
                    style={{
                      height: '48px',
                      padding: '0 24px',
                      fontSize: '16px',
                      fontWeight: 500,
                      borderRadius: '6px',
                      backgroundColor: '#000000',
                      borderColor: '#000000',
                      color: '#ffffff'
                    }}
                  >
                    Setup
                  </Button>
                </Link>
              </div>
            </Card>
          </>
        )}

        {/* Buy Tipping Stands Section - Only show for Team Admins/Managers when team has less than 2 tags */}
        {client && (isTeamAdmin || (team && team.teamOwnerClientId === clientId)) && tagsCount < 2 && (
          <BuyTippingStandsSection
            clientId={clientId}
            client={client}
            screenWidth={screenWidth}
            isAdmin={isAdmin}
            brand="teamkit"
            teamId={teamId}
            team={team}
          />
        )}

        <SmartPosCTA team={team} teamId={teamId} canManage={isTeamAdmin || isAdmin} clientId={clientId} />

        {/* Reports Section - Show before Members */}
        {shouldShowReports && (
          <>
            <Divider orientation='left'>Reports</Divider>
            <TeamPofileTeamMembersActions teamId={teamId} permissions={displayPermissions} isOldTeamSettings={isOldTeamSettings} isMobile={isMobile} />
          </>
        )}

        {(displayPermissions && displayPermissions.canSeeMembers || canAccessSettings) &&
          <div style={{ width: '100%' }}>
            <Divider
              orientation='left'
              style={{ width: '100%' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', width: '100%' }}>
                <TeamMembersSummary 
                  team={team}
                  isAdmin={isAdmin}
                  displayPermissions={displayPermissions}
                />
                {isTeamAdmin && (
                  <Link 
                    to={isOldTeamSettings ? `./${teamId}/oldsettings` : `./${teamId}/settings#general-settings`} 
                    style={{ display: 'flex', alignItems: 'center', gap: '4px', marginLeft: 'auto' }}
                  >
                    <Text style={{ fontSize: '14px', color: '#1890ff' }}>Permissions</Text>
                    <EditOutlined style={{ fontSize: '14px', color: '#1890ff' }} />
                  </Link>
                )}
              </div>
            </Divider>

            <TeamMembersGrid
              condition={true}
              locStrings={locStrings}
              members={teamMembers}
              teamId={teamId}
              team={team}
              clientId={clientId}
              displayPermissions={displayPermissions}
              isInviteVisible={isInviteVisible}
              teamTapBehaviour={team.teamTapBehaviour}
              onChange={() => (true)}
              isAdmin={isAdmin}
            />

          </div>
        }

        {/* Recent Activity Section */}
        {clientId && team && teamId && displayPermissions &&
          <>
            <Divider orientation='left'>Recent Activity</Divider>
            <TeamProfileRecentActivityList
              teamId={teamId}
              clientId={clientId}
              displayPermissions={displayPermissions}
              locStrings={locStrings}
              team={team}
              isAdmin={isAdmin}
            />
          </>
        }

        {/* Devices and QRs Section - Show at bottom when tags count !== 1 */}
        {team && isTeamAdmin && (
          <>
            <Divider orientation='left'>Devices and QRs</Divider>
            <DevicesAndQRSection
              isTeamAdmin={isTeamAdmin}
              isMobile={isMobile}
              teamId={teamId}
              team={team}
              clientId={clientId}
              yourself={yourself}
              user={user}
            />
          </>
        )}

        {/* Dangerous Action - Delete team (owner only, when sole member) */}
        {clientId && team && clientId === team.teamOwnerClientId && team.teamNumberOfMembers === 1 && (
          <>
            <Divider orientation='left'>Danger Zone</Divider>
            <Card
              style={{
                width: '100%',
                borderRadius: '8px',
                border: '1px solid #ff4d4f',
                backgroundColor: '#fff2f0',
                boxShadow: '0 2px 8px rgba(255,77,79,0.15)',
                marginBottom: '24px'
              }}
              bodyStyle={{ padding: '20px' }}
            >
              <div style={{
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                alignItems: isMobile ? 'flex-start' : 'center',
                justifyContent: 'space-between',
                gap: '16px'
              }}>
                <div style={{ flex: 1, minWidth: isMobile ? '0' : '200px', width: isMobile ? '100%' : 'auto' }}>
                  <Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '8px', color: '#cf1322' }}>
                    Delete your access to this team
                  </Text>
                  <Text style={{ fontSize: '14px', display: 'block', color: '#595959' }}>
                    This will permanently remove your access. No one will be able to access the team. Your tip history will be maintained for records.
                  </Text>
                </div>
                <div style={{ flexShrink: 0, width: isMobile ? '100%' : 'auto' }}>
                  <TeamMemberLeaveButton
                    clientId={clientId}
                    team={team}
                    isAdmin={isAdmin}
                    style={{
                      border: '1px solid #ff4d4f',
                      backgroundColor: 'white',
                      color: '#ff4d4f',
                      borderRadius: '6px',
                      height: '40px',
                      padding: '0 24px',
                      fontSize: '16px',
                      fontWeight: 500,
                      width: isMobile ? '100%' : 'auto'
                    }}
                  />
                </div>
              </div>
            </Card>
          </>
        )}

      </Card>

    </>
  ) : <LoadingCard loading={true} qr={isQRVisible} />;

};




const LoadingCard = ({ loading, qr }) => {
  return loading ? (
    <>
      <Card
        title={<Skeleton.Button size={'small'} active />}
      >
        <Skeleton active avatar />
        <Divider />
        <Space direction='vertical'>
          {qr &&
            <SkeletonImage active style={{ width: '200px', height: '200px' }} />
          }
          <SkeletonButton active style={{ width: '200px', height: '44px' }} />
          <Divider />
          <SkeletonButton shape='round' active size='large' />
          <SkeletonAvatar active />
          <SkeletonAvatar active />
          <SkeletonAvatar active />
          <SkeletonAvatar active />
          <SkeletonAvatar active />
        </Space>
      </Card>

    </>
  ) : null;

};



export default TeamProfileScreenBody;
